/* ============================================================
   ct-pdp-combi.js  |  Cosmetique Totale — combivoordeel-blok
   ------------------------------------------------------------
   Geladen met defer vanuit snippets/ct-pdp-combi.liquid.
   1. Gift: zoekt via window.ctEasyGift (assets/ct-eg-rules.js) de actieve
      EasyGift-regel met een AANTAL-drempel: eerst op de combivoordeel-
      collectie, anders drempel 2 op een collectie van dit product. Toont
      naam, waarde en foto. Keuzeregel → "cadeau naar keuze".
      Geen regel of gift niet leverbaar → gift-regel blijft verborgen.
   2. Stand: telt via /cart.js de betaalde deelnemende producten in de
      mand (product_id in data-ids) en zet data-state:
        idle (0 andere), almost (≥1 ander, dit product nog niet),
        active (≥2 deelnemende stuks). Opnieuw na ajaxProduct:added en
      bij terugkeer naar het tabblad.
   3. "Kies je tweede product": accordeon. Het witte vlak schuift uit tot
      de volle breedte en klapt open met alleen de deelnemende producten
      (zie initRow). Kaartknop = "Beide toevoegen": voegt dit product
      (gekozen variant) + de kaart in één call toe, tenzij dit product al
      in de mand zit (data-self-in-cart, gezet door initState).
   ============================================================ */
(() => {
  'use strict';

  const fmt = (cents) => {
    if (window.theme && theme.Currency && theme.settings) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    return new Intl.NumberFormat(document.documentElement.lang || 'nl', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  };
  const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  /* Het winkelprijsformaat bevat HTML (<span class="notranslate ht-money">,
     van de valuta-/vertaalapp). Alleen de tekst gebruiken; DOMParser voert
     niets uit. Bug 13-10: de span verscheen letterlijk in de gift-regel. */
  const plain = (html) => {
    const s = String(html || '');
    if (s.indexOf('<') === -1 && s.indexOf('&') === -1) return s;
    return (new DOMParser().parseFromString(s, 'text/html').body.textContent || '').trim();
  };

  function initGift(root) {
    const collId = root.dataset.collectionId;
    const line = root.querySelector('[data-ct-combi-gift]');
    const text = root.querySelector('[data-ct-combi-gift-text]');
    const media = root.querySelector('[data-ct-combi-gift-media]');
    const eg = window.ctEasyGift;
    if (!collId || !line || !eg) return;

    /* Collecties van dit product (Liquid); gebruikt als de regel niet op
       de combivoordeel-collectie zelf draait maar bijv. op "Dermaceutic
       huidverzorging" (bestaande regel FREE-Gift, 13-10). */
    const ownCols = (root.dataset.productCollections || '').split(',').filter(Boolean);

    eg.ready(() => {
      const qty = eg.tiers().filter((t) => t.thresholdType === 'quantity');
      const tier =
        qty.find((t) => t.collections.indexOf(String(collId)) !== -1) ||
        qty.find((t) => t.threshold === 2 && t.collections.some((c) => ownCols.indexOf(c) !== -1));
      if (!tier) return;

      if (tier.choice) {
        text.textContent = root.dataset.choiceTpl || '';
        line.hidden = false;
        return;
      }
      const vid = tier.gifts[0];
      if (!vid) return;
      const render = (d) => {
        if (!d || d.available === false || !d.title) return;
        const tpl = root.dataset.giftTpl || '[gift]';
        text.innerHTML = esc(tpl)
          .replace('[gift]', '<strong>' + esc(d.title) + '</strong>')
          .replace('[value]', esc(plain(fmt(d.price))));
        if (d.image) {
          media.innerHTML = '<img src="' + esc(d.image) + '" alt="" loading="lazy" width="38" height="38">';
          media.hidden = false;
        }
        line.hidden = false;
      };
      const hit = eg.giftInfo('v:' + vid, render);
      if (hit) render(hit);
    });
  }

  function initState(root) {
    const ids = (root.dataset.ids || '').split(',').filter(Boolean);
    const self = String(root.dataset.productId || '');
    const base = root.dataset.root || '/';
    if (!ids.length) return;

    const setState = (state) => {
      root.dataset.state = state;
      root.querySelectorAll('[data-ct-combi-title]').forEach((el) => { el.hidden = el.dataset.ctCombiTitle !== state; });
    };

    const check = () => {
      fetch((base.slice(-1) === '/' ? base : base + '/') + 'cart.js', { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.json() : null))
        .then((cart) => {
          if (!cart || !cart.items) return;
          let total = 0;
          let others = 0;
          let hasSelf = false;
          cart.items.forEach((it) => {
            if (it.final_line_price <= 0 || ids.indexOf(String(it.product_id)) === -1) return;
            total += it.quantity;
            if (String(it.product_id) === self) hasSelf = true; else others += it.quantity;
          });
          root.dataset.selfInCart = hasSelf ? '1' : '0';
          root.dispatchEvent(new CustomEvent('ct-combi:self', { detail: { inCart: hasSelf } }));
          if (total >= 2) setState('active');
          else if (others >= 1 && !hasSelf) setState('almost');
          else setState('idle');
        })
        .catch(() => {});
    };

    check();
    document.addEventListener('ajaxProduct:added', () => setTimeout(check, 400));
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') check(); });
  }

  /* 3. Uitklaprij met alleen deelnemende producten. Kaarten komen uit
     <template data-ct-combi-cards> (snippets/ct-cart-upsell-row); bij de
     eerste keer openen gaan ze de track in, zonder het huidige product.
     Toevoegen: zelfde route als de upsell in ct-pdp.js (cart/add.js met
     sections, daarna ajaxProduct:added zodat de drawer opent). */
  function fixSizes(track) {
    const first = track.firstElementChild;
    const w = first ? Math.round(first.getBoundingClientRect().width) : 0;
    track.querySelectorAll('img[srcset]').forEach((img) => {
      img.sizes = w > 0 ? w + 'px' : '(min-width: 769px) 280px, 45vw';
    });
  }

  function initRow(root) {
    const acc = root.querySelector('[data-ct-combi-acc]');
    const toggle = root.querySelector('[data-ct-combi-toggle]');
    const body = root.querySelector('[data-ct-combi-body]');
    const row = root.querySelector('[data-ct-combi-row]');
    if (!acc || !toggle || !body || !row) return;
    const track = row.querySelector('[data-ct-scroll-track]');
    const tpl = row.querySelector('template[data-ct-combi-cards]');
    const self = String(root.dataset.productId || '');
    let filled = false;

    /* Breedte: dicht = precies de knop (tekst + pijl), open = de kaart.
       Beide in px, zodat max-width kan animeren. */
    const label = toggle.querySelector('.ct-combi__link-text');
    const arrow = toggle.querySelector('.ct-combi__arrow');
    const closedWidth = () => {
      const cs = getComputedStyle(toggle);
      const pad = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight) + parseFloat(cs.columnGap || cs.gap || 0);
      return Math.ceil((label ? label.scrollWidth : 0) + (arrow ? arrow.offsetWidth : 0) + pad);
    };
    const fullWidth = () => acc.parentElement.clientWidth - parseFloat(getComputedStyle(acc.parentElement).paddingLeft) - parseFloat(getComputedStyle(acc.parentElement).paddingRight);
    const sizeAcc = () => {
      const open = acc.classList.contains('is-open');
      acc.style.maxWidth = (open ? fullWidth() : Math.min(closedWidth(), fullWidth())) + 'px';
    };
    sizeAcc();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sizeAcc);
    window.addEventListener('resize', sizeAcc);

    const fill = () => {
      if (filled || !tpl || !track) return;
      filled = true;
      const tmp = document.createElement('div');
      tmp.appendChild(tpl.content.cloneNode(true));
      tmp.querySelectorAll('.ct-upsell-item').forEach((card) => {
        if (card.dataset.productId === self) return;
        track.appendChild(card);
      });
      if (!track.children.length) acc.hidden = true;
      relabel();
    };

    /* Knoptekst: "Beide toevoegen" zolang dit product niet in de mand zit. */
    const relabel = () => {
      if (!track) return;
      const both = root.dataset.selfInCart !== '1';
      const label = both ? root.dataset.labelBoth : root.dataset.labelOne;
      if (!label) return;
      track.querySelectorAll('[data-ct-upsell-add]').forEach((btn) => {
        const card = btn.closest('.ct-upsell-item');
        const t = card && card.querySelector('.ct-upsell-item__title');
        const vis = btn.querySelector('[aria-hidden="true"]');
        const sr = btn.querySelector('.visually-hidden');
        if (vis) vis.textContent = label;
        if (sr) sr.textContent = label + (t ? ' \u2014 ' + t.textContent.trim() : '');
      });
    };
    root.addEventListener('ct-combi:self', relabel);

    /* Variant van dit product: uit het productformulier (volgt de
       variantkeuze), anders de Liquid-standaard. */
    const selfVariant = () => {
      const scope = root.closest('[data-section-type="product"]') || root.closest('product-component') || document;
      const field = scope.querySelector('form[action*="/cart/add"] [name="id"]');
      return (field && field.value) || root.dataset.selfVariant || '';
    };

    toggle.addEventListener('click', () => {
      const open = !acc.classList.contains('is-open');
      fill();
      acc.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) body.removeAttribute('inert'); else body.setAttribute('inert', '');
      sizeAcc();
      if (open) requestAnimationFrame(() => fixSizes(track));
    });

    row.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-ct-upsell-add]');
      if (!btn || btn.classList.contains('btn--loading')) return;
      e.preventDefault();
      btn.classList.add('btn--loading');
      const routes = (window.theme && theme.routes) || {};
      const cardItem = { id: btn.dataset.variantId, quantity: 1 };
      const self = selfVariant();
      const both = root.dataset.selfInCart !== '1' && self && String(self) !== String(btn.dataset.variantId);
      const post = (items) => fetch(routes.cartAdd || '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items, sections: 'ct-cart-ajax', sections_url: window.location.pathname })
      }).then((r) => r.json());
      const isErr = (d) => d && (d.status === 422 || d.status === 'bad_request');

      /* Beide in één call (dit product eerst). Faalt dat, bijv. omdat dit
         product uitverkocht is, dan alsnog alleen de kaart. */
      (both ? post([{ id: self, quantity: 1 }, cardItem]).then((d) => (isErr(d) ? post([cardItem]) : d)) : post([cardItem]))
        .then((data) => {
          btn.classList.remove('btn--loading');
          if (isErr(data)) {
            if (data.description) window.alert(data.description);
            return;
          }
          btn.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            bubbles: true,
            detail: { product: data, addToCartBtn: btn, sections: data.sections || null }
          }));
        })
        .catch(() => btn.classList.remove('btn--loading'));
    });
  }

  function init(root) {
    if (root.dataset.ctInit) return;
    root.dataset.ctInit = '1';
    initGift(root);
    initState(root);
    initRow(root);
  }

  const initAll = (scope) => (scope || document).querySelectorAll('[data-ct-combi]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
